const investmentDisclaimerLang = {
	info_tooltip: {
		tag: 'investment.disclaimer.info_tooltip',
		fr: 'Les performances passées des stratégies d’investissement présentées sur ce portail ainsi que les simulations réalisées sur la base de ces dernières ne sont pas un indicateur fiable des performances futures. Elles ne préjugent pas des performances futures.',
		en: 'The past performances of investment strategies presented in this portal and any projections derived therefrom are not a reliable indicator of future performance. Past performance cannot be construed as an indicator of future performance.',
	},
	kpi_warning: {
		tag: 'investment.disclaimer.kpi_warning',
		fr: 'Attention: Les indicateurs inclus les flux financiers des (ou du) fonds liquidés',
		en: 'Warning: the KPIs include the financials flows of liquidated fund(s)',
	},
};

export default investmentDisclaimerLang;
